// import { createSelector } from 'reselect';

export const getIsDeleting = state => state.getIn(['reviewNotes', 'isDeleting']);
export const getErrMsg = state => state.getIn(['reviewNotes', 'errMsg']);

export const getNoteIdList = state => state.getIn(['reviewNotes', 'noteIdList']);
export const getNotes = state => state.getIn(['reviewNotes', 'notes']);
